var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 2,
    fill: "#DADFF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62483 17.375H17.8322V19H7V7.625C7 6.73125 7.73117 6 8.62483 6H14.7884L17.8322 9.06583V10.3333H13.4993V7.625H8.62483V17.375ZM19.8416 13.4696L17.8322 11.4167V13.0417H13.4993V14.6667H17.8322V16.2917L19.8416 14.2388C20.0528 14.0275 20.0528 13.6863 19.8416 13.475V13.4696Z",
    fill: "#173CFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportExport);
export default __webpack_public_path__ + "static/media/reportExport.6de379a80353e752409d5fd8eaeab946.svg";
export { ForwardRef as ReactComponent };